import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SubProjectControllerRequestService } from '../../../../services/api/sub-project-controller-request.service';
import { ImmoInvoiceSubProjectsControllerRequestService } from './service/immo-invoice-sub-projects-controller-request.service';
import { ImmoBillingSubProject } from './model/immo-billing-sub-project';
import { AbstractImmoOverviewComponent } from '../abstract-immo-overview.component';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { FilterStoreService } from '../../../../services/filter-store.service';
import { PageIndexService } from '../../../../services/page-index-service';
import { Lightbox } from 'ngx-lightbox';
import { Router } from '@angular/router';
import {
  ModalService,
  ObservableHandlerPair,
} from '../../../../services/modal.service';
import { ImmoBillingDetailComponent } from '../billing-detail/immo-billing-detail.component';
import { SnackService } from '../../../../services/snack.service';
import { SimpleLoggedAction } from '../../../../model/simple-logged-action';
import { CollectionHelper } from 'src/app/helpers/collection-helper';

@Component({
  selector: 'immo-billing-overview',
  templateUrl: './immo-billing-overview.component.html',
  styleUrls: ['./immo-billing-overview.component.scss'],
})
export class ImmoBillingOverviewComponent
  extends AbstractImmoOverviewComponent<ImmoBillingSubProject>
  implements OnInit
{
  itemsByCompanyName: Map<string, ImmoBillingSubProject[]>;
  companyNames: string[];

  saving: boolean;

  @Output()
  countChange = new EventEmitter<number>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected cd: ChangeDetectorRef,
    protected subProjectService: SubProjectControllerRequestService,
    protected immoInvoiceSubProjectsControllerRequestService: ImmoInvoiceSubProjectsControllerRequestService,
    protected _lightbox: Lightbox,
    protected router: Router,
    private modalService: ModalService,
    private snackService: SnackService
  ) {
    super(
      [
        {
          key: 'project__id',
          active: false,
          strictEquality: true,
          numeric: true,
        },
        {
          key: 'immoNewCustomerName',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'needsBillingReadyConfirmation',
          active: true,
          strictEquality: false,
          numeric: false,
        },
      ],
      filterStoreService,
      pageIndexService,
      cd,
      subProjectService,
      _lightbox,
      router
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected getPaginator(): MatPaginator {
    return this.paginator;
  }
  protected initDisplayedColumns(): void {
    this.displayedColumns = [
      'projectId',
      'requestDate',
      'executionDate',
      'placer',
      'address',
      'productConfig',
      'displayStatus',
      'checkedBy',
    ];
  }
  public openTour(subProject: ImmoBillingSubProject): void {
    throw new Error('Method not implemented.');
  }
  public copyProjectId(subProject: ImmoBillingSubProject): void {
    throw new Error('Method not implemented.');
  }
  protected initSortSettings(): void {
    this.sortColumn = 'currentExecutionDate';
    this.sortAscending = true;
  }

  protected fetchItems(): void {
    this.loading = true;
    this.items = [];

    this.subProjectService
      .getImmoBilling(
        this.generateFilterString(),
        this.sortColumn,
        this.sortAscending,
        this.paginator.pageSize,
        this.paginator.pageIndex
      )
      .then((res) => {
        this.processPageResult(res);
        this.totalItems = res.totalItems;
        this.items = res.items;
        this.groupItemsByCompanyName();
        this.countChange.emit(res.totalItems);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private groupItemsByCompanyName(): void {
    const keys: string[] = [];
    const result: Map<string, ImmoBillingSubProject[]> = new Map();
    this.items.forEach((item) => {
      this.assignParsedFields(item);
      if (result.has(item.companyName)) {
        result.get(item.companyName).push(item);
      } else {
        keys.push(item.companyName);
        result.set(item.companyName, [item]);
      }
    });

    this.companyNames = keys;
    this.itemsByCompanyName = result;
  }

  private assignParsedFields(item: ImmoBillingSubProject) {
    if (item.billingReady != null && item.billingReady.date != null) {
      item.bgClass = 'approved';
    } else {
      item.bgClass = '';
    }
    if (
      item.project != null &&
      CollectionHelper.isPopulated(item.project.products)
    ) {
      item.project.firstProduct = item.project.products[0];
    }
  }

  public openProject(subProject: ImmoBillingSubProject) {
    const compInputs = [{ key: 'subProjectId', value: subProject.id }];
    this.modalService.openComponentInModal(
      ImmoBillingDetailComponent,
      compInputs,
      new ObservableHandlerPair(
        (modalRef) => modalRef.componentInstance.billingChecked,
        (billingReady: SimpleLoggedAction) => {
          subProject.billingReady = billingReady;
          this.assignParsedFields(subProject);
        }
      ),
      {},
      false
    );
  }

  protected getLocalStorageKey(): string {
    return 'ImmoBillingOverviewComponent';
  }

  createInvoice(companyName: string): void {
    this.saving = true;
    const items = this.itemsByCompanyName.get(companyName);

    const toInvoice = items.filter(
      (i) => i.billingReady != null && i.billingReady.date != null
    );

    if (toInvoice.length === 0) {
      this.snackService.showWarning(
        `Geen facturen te versturen naar Teamleader voor ${companyName}`
      );
      this.saving = false;
      return;
    }

    const subProjectIds = toInvoice.map((i) => i.id);
    const companyId = toInvoice[0].companyId;

    this.immoInvoiceSubProjectsControllerRequestService
      .invoiceSubProjects(subProjectIds, companyId)
      .then((res) => {
        if (res.success) {
          this.snackService.showSuccess(res.message);
          this.fetchItems();
        } else {
          this.snackService.showError(res.message);
        }
      })
      .finally(() => (this.saving = false));
  }
}
